import dayjs, { type OpUnitType, type QUnitType } from 'dayjs';

export default function TimeDifference({
  from,
  to,
  unit = 'days',
}: {
  from?: string;
  to: string;
  unit?: QUnitType | OpUnitType;
}) {
  const diff = dayjs(to).endOf('day').diff(dayjs(from).startOf('day'), unit);
  return <>{diff}</>;
}
